<template>
    <div>
        <div class="no-padding">
            <h2 class="hide-xs no-margin" v-text="lang.payment_data"></h2>
            <p class="no-padding no-margin green">
                <span class="hep-schloss"></span>
                {{ lang.encrypted_connection }}
            </p>
            <p v-text="lang['3ds_hint']"></p>
        </div>
        <div><div id="dropin-container"></div></div>
    </div>
</template>

<script>

import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import axios from 'axios';

const ADYEN_AUTHORISATION_STATUS = 'Authorised';
const ADYEN_RECEIVED_STATUS = 'Received';
const ADYEN_REFUSED_STATUS = 'Refused';
const ADYEN_ERROR_STATUS = 'Error';
const CURRENCY_EUR = 'EUR';

export default {
    name: 'adyen-drop-in',
    props: ['session', 'sessionId', 'clientKey', 'environment', 'redirectUrl', 'redirectResult', 'lang', 'locale',
        'shopperReference', 'merchantReference', 'price', 'countryCode', 'updateContract'],

    data: function () {
        return {
            orderId: null,
            paymentMethod: null
        }
    },

    mounted: function () {
        const that = this;
        const configuration = {
            environment: this.environment,
            clientKey: this.clientKey,
            session: {
                id: this.sessionId || this.session.id,
                sessionData: this.session ? this.session.sessionData : null
            },
            onPaymentCompleted: (result, component) => {
                if (result.resultCode === ADYEN_AUTHORISATION_STATUS || result.resultCode === ADYEN_RECEIVED_STATUS) {
                    if (that.updateContract) {
                        that.activateContract(that.paymentMethod).then(() => {
                            that.redirecToCallbackPage(result);
                        }).catch(() => {
                            that.enableBackButtons();
                            component.setStatus('error', {message: that.lang.orderError});
                        });
                    } else {
                        that.redirecToCallbackPage(result);
                    }
                } else if (result.resultCode === ADYEN_REFUSED_STATUS || result.resultCode === ADYEN_ERROR_STATUS) {
                    that.cancelOrder();
                    that.enableBackButtons();
                    component.setStatus('error', {message: that.lang.paymentNotAuthorized});
                }
            },
            onError: (error, component) => {
                that.cancelOrder();
                that.enableBackButtons();
                component.setStatus('error', {message: that.lang.orderError});
                console.error(error.name, error.message, error.stack, component);
            },
            beforeSubmit: (state, component, actions) => {
                that.disableBackButtons();
                that.paymentMethod = state.paymentMethod.brand || state.paymentMethod.type;
                if (!that.updateContract) {
                    that.createOrder(that.paymentMethod).then((response) => {
                        that.orderId = response.data;
                        actions.resolve(state);
                    }).catch(() => {
                        that.enableBackButtons();
                        component.setStatus('error', {message: that.lang.orderError});
                    });
                } else {
                    actions.resolve(state);
                }
            },
            paymentMethodsConfiguration: {
                card: {
                    hasHolderName: true,
                    holderNameRequired: true,
                    billingAddressRequired: false
                },
                paypal: {
                    blockPayPalCreditButton: true,
                    blockPayPalPayLaterButton: true
                },
                applepay: {
                    amount: {
                        value: that.price,
                        currency: CURRENCY_EUR
                    },
                    countryCode: that.countryCode,
                }
            },
            analytics: {
                enabled: false
            }
        };

        if (this.redirectResult) {
            AdyenCheckout(configuration).then(checkout => {
                checkout.submitDetails({
                    details: {
                        redirectResult: this.redirectResult
                    }
                });
            });
        }

        AdyenCheckout(configuration).then((dropin) => {
            dropin.create('dropin').mount('#dropin-container')
        });
    },

    methods: {
        createOrder: function (paymentMethod) {
            return axios.post('/' + this.locale + '/checkout/createOrder', {
                method: paymentMethod,
                shopperReference: this.shopperReference,
                merchantReference: this.merchantReference
            });
        },

        activateContract: function (paymentMethod) {
            return axios.post('/' + this.locale + '/checkout/activateContract', {
                paymentMethod
            });
        },

        cancelOrder: function () {
            if (!this.updateContract) {
                axios.post('/' + this.locale + '/checkout/cancelOrder', {
                    orderId: this.orderId,
                });
            }
        },

        disableBackButtons: function () {
            document.querySelectorAll('#checkoutApp button').forEach((button) => button.disabled = true);
        },

        enableBackButtons: function () {
            document.querySelectorAll('#checkoutApp button').forEach((button) => button.disabled = false);
        },

        redirecToCallbackPage: function (result) {
            const url = new URL(this.redirectUrl);
            url.searchParams.set('authResult', result.resultCode);
            window.open(url.toString(), '_self');
        }
    }
}
</script>

<style scoped>

h2 {
    font-size: 18px;
    font-weight: 600;
    font-style: normal;
    font-variant: normal;
    margin-top: 0;
    text-align: left;
    text-transform: none;
}

.hep-schloss {
    font-size: 36px;
    position: relative;
    top: 10px;
    line-height: 0;
}

.green {
    color: #0f8e00;
}

</style>
